export default "__VITE_ASSET__U$_UCs$A__"